import { Model } from '@/models/Model';
export class Label extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Label';
        this.$endpoint = '/labels';
        this.$fillable = ['key', 'value'];
    }
    resolvePrimaryKey() {
        return '';
    }
}
